<template>
  <div class="home-page">
    <myHead :stylehead="stylehead"></myHead>
    <section class="time-section">
      <img class="img img1" width="100%" src="../assets/homebg.png" />
      <img class="img img2" src="../assets/homebg2.png" alt="">
      <h4 class="sub-title">
        GAME MAKES LIFE MORE INTERESTING
        <!-- <span class="home-line"></span> -->
        
        <!-- <span class="home-line"></span> -->
      </h4>
      <!-- <div class="more-icon">
        <a href="#two"></a>
      </div> -->
      <!-- <div class="bottom-box">
        <img src="../assets/bottom.png" alt="">
      </div> -->
    </section>
    <div class="body">
      <div class="about" id="about">
        <img class="img1" src="../assets/aboutbg.png" alt="">
        <img class="img2" src="../assets/aboutbg2.png" alt="">
        <div class="tit">
          A LEADING GLOBAL ONLINE GAMES PUBLISHER
        </div>
      </div>
      <!--<div class="games" id="games">
        <div class="tit">GAMES</div>
        <div class="list">
          <div class="item">
            <img src="../assets/games09.png" alt="">
            <div class="span" style="text-align:center">我在荒島開派對</div>
          </div>
          <div class="item">
            <img src="../assets/games10.png" alt="">
            <div class="span" style="text-align:center">我的小海島</div>
          </div>
          <div class="item">
            <img src="../assets/games11.png" alt="">
            <div class="span" style="text-align:center">傭兵小鎮</div>
          </div>
          <div class="item">
            <img src="../assets/games04.png" alt="">
            <div class="span" style="text-align:center">OIL ERA</div>
          </div>
        </div>
        <br/>
        <div class="list">
          <div class="item">
            <img src="../assets/games05.png" alt="">
            <div class="span" style="text-align:center">LUDO LAND</div>
          </div>
          <div class="item">
            <img src="../assets/games03.png" alt="">
            <div class="span" style="text-align:center">住客大人的心願</div>
          </div>
          <div class="item">
            <img src="../assets/games06.png" alt="">
            <div class="span" style="text-align:center">BEAT SLASH</div>
          </div>
          <div class="item">
            <img src="../assets/games07.png" alt="">
            <div class="span" style="text-align:center">BEAT SLASH 2</div>
          </div>
        </div>
        <div class="list">
          <div class="item">
            <img src="../assets/games08.png" alt="">
            <div class="span" style="text-align:center">DANCING DOG</div>
          </div>
          <div class="item">
            <div class="span" style="text-align:center"></div>
          </div>
          <div class="item">
            <div class="span" style="text-align:center"></div>
          </div>
          <div class="item">
            <div class="span" style="text-align:center"></div>
          </div>
        </div>
      </div>-->
      <div class="features" id="features">
        <div class="tit">FEATURES</div>
        <div class="list">
          <div class="item">
            <img src="../assets/features01.png" alt="">
            <div class="span">Globalisation</div>
            <div class="info">We are committed to publishing high-quality games to the global market.</div>
          </div>
          <div class="item">
            <img src="../assets/features02.png" alt="">
            <div class="span">Professional</div>
            <div class="info">With a strong team and rich resources, we are experts in overseas distribution.</div>
          </div>
          <div class="item">
            <img src="../assets/features03.png" alt="">
            <div class="span">Localisation</div>
            <div class="info">We care about the characteristics of each market &committed to making every player enjoy it.</div>
          </div>
        </div>
      </div>
      <div class="map">
        <img class="img1" src="../assets/footerbg.png" alt="">
        <img class="img2" src="../assets/footerbg2.png" alt="">
        <div class="tit tit1">A LEADING GLOBAL ONLINE GAMES PUBLISHER</div>
        <!--<div class="tit tit2">22 N Canal Rd, Singapore</div>-->
      </div>
    </div>
    <myFoot />
    <!-- <goTop /> -->
  </div>
</template>

<script>
import myHead from "@/components/header";
import myFoot from "@/components/footer";
import goTop from "@/components/goTop";

export default {
  data() {
    return {
      stylehead: {
        color: "#FFFFFF",
        background: "transparent",
      },
      positive: "absolute",
    };
  },
  created() {
    // console.log(this.language);
  },
  methods: {
    changeLanguage(lang) {
      this.language = lang;
    },
  },
  components: {
    myHead,
    myFoot,
    goTop,
  },
};
</script>

<style lang="scss" scoped>
@keyframes bounce-down {
  25% {
    transform: translateY(-10px);
  }
  50% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0);
  }
}
.home-page {
  position: relative;
  // padding-bottom: 100px;

  @media screen and (min-width: 350px) and (max-width: 750px) {
    .time-section {
      .img2 {
        display: block;
      }
      .sub-title {
        font-size: 28px;
      }
    }
    .body {
      .about {
        .img2 {
          display: inline;
        }
      }
      .games,
      .features {
        .tit {
          font-size: 24px;
        }
      }
      .games {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .features {
        .list {
          display: block;
          .item {
            padding: 0px 20px;
            margin-bottom: 30px;
            img {
              width: 100px;
            }
            .span {
              font-size: 20px;
            }
            .info {
              font-size: 16px;
            }
          }
        }
      }
      .map {
        .img2 {
          display: inline;
        }
        .tit {
          line-height: 26px;
          padding: 0px 30px;
          box-sizing: border-box;
          font-size: 20px;
        }
        .tit1 {
          top: 60px;
        }
        .tit2 {
          bottom: 60px;
        }
      }
    }
  }
  @media screen and (min-width: 751px) {
    .time-section {
      .img1 {
        display: block;
      }
      .sub-title {
        font-size: 40px;
      }
    }
    .body {
      .about {
        .img1 {
          display: inline;
        }
      }
      .games,
      .features {
        .tit {
          font-size: 30px;
        }
      }
      .features {
        .list {
          display: flex;
          justify-content: center;
          .item {
            width: 200px;
            margin: 0px 40px;
            img {
              width: 70%;
            }
            
            .span {
              font-size: 22px;
            }
            .info {
              font-size: 18px;
            }
          }
        }
      }
      .map {
        .img1 {
          display: inline;
        }
        .tit {
          font-size: 26px;
        }
        .tit1 {
          top: 40px;
        }
        .tit2 {
          bottom: 40px;
        }
      }
    }
  }

  .time-section {
    position: relative;
    >img {
      display: none;
      max-width: 100%;
      border: none;
      outline: none;
    }
    .sub-title {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 0%;
      transform: translateY(-50%);
      line-height: 40px;
      color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-family: PingFang SC;
      font-weight: bold;
      text-align: center;
      .home-line {
        display: inline-block;
        width: 70px;
        height: 3px;
        background: rgba(255, 255, 255, 0.5);
      }
      img {
        width: 75%;
      }
    }
    .bottom-box {
      position: absolute;
      left: 50%;
      bottom: 50px;
      transform: translateX(-50%);
      img {
        width: 88px;
        height: 44px;
      }
    }
  }
  .body {
    width: 100%;
    background: #fff;
    
    .about {
      position: relative;
      img {
        display: none;
        width: 100%;
      }
      .tit {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 0px;
        transform: translateY(-50%);
        text-align: center;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #D82237;
      }
    }
    .games,
    .features {
      padding: 30px 0px 50px;
      .tit {
        height: 80px;
        line-height: 80px;
        text-align: center;
        font-family: PingFang SC;
        font-weight: bold;
        color: #D82237;
        margin: 30px 0px;
      }
    }
    .games {
      .list {
        display: flex;
        justify-content: center;

        .item {
          width: 200px;
          margin: 0px 20px;

          img {
            width: 100%;
          }
        }
      }
    }
    .features {
      background-color: #faf7f7;
      .list {

        .item {
          text-align: center;
          .span {
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            margin: 10px 0px;
          }
          .info {
            font-family: PingFang SC;
            color: #666666;
          }
        }
      }
    }
    .map {
      position: relative;
      img {
        display: none;
        width: 100%;
        vertical-align: middle;
      }
      .tit {
        width: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        font-family: PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
      }
    }
  }
}
</style>
